import { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

const InfoIcon = ({ content }) => {
    const [show, setShow] = useState(false);
  
    return (
      <div style={{ position: 'relative', display: 'inline-block', marginLeft: '0.25rem' }}>
        <button
          type="button"
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          onClick={() => setShow(!show)}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer'
          }}
        >
          <FaInfoCircle style={{ color: '#3b82f6', fontSize: '0.9rem' }} />
        </button>
        {show && (
          <div style={{
            position: 'absolute',
            zIndex: 10,
            width: '200px',
            background: 'white',
            border: '1px solid #e5e7eb',
            borderRadius: '0.5rem',
            padding: '0.75rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            left: '100%',
            top: 0,
            fontSize: '0.8rem'
          }}>
            {content}
          </div>
        )}
      </div>
    );
  };

export default InfoIcon;